import axios from 'axios';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
  e.preventDefault();
  try {
    await axios.get("https://api.softmri.com/sanctum/csrf-cookie", { withCredentials: true });
    const response = await axios.post(`${BASE_URL}/login`, {
      email,
      password,
    }, { withCredentials: true });

    if (response.status === 200) {
      const expiry = Date.now() + 60 * 60 * 1000; // 1 hour expiry

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('token_expiry', expiry); // key name fixed
      navigate('/dashboard'); 
    }
  } catch (err) {
    alert('Login failed');
  }
};

  return (
    <div className="container-xxl">
      <div className="row vh-100 d-flex justify-content-center">
        <div className="col-12 align-self-center">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-4 mx-auto">
                <div className="card">
                  <div className="card-body p-0 bg-black auth-header-box rounded-top">
                    <div className="text-center p-3">
                      <Link to="/" className="logo logo-admin">
                        <img
                          src="/assets/images/logo-sm.png"
                          height="50"
                          alt="logo"
                          className="auth-logo"
                        />
                      </Link>
                      <h4 className="mt-3 mb-1 fw-semibold text-white fs-18">
                        Let's Get Started Rizz
                      </h4>
                      <p className="text-muted fw-medium mb-0">
                        Sign in to continue to Rizz.
                      </p>
                    </div>
                  </div>
                  <div className="card-body pt-0">
                    <form className="my-4" onSubmit={handleLogin}>
                      <div className="form-group mb-2">
                        <label className="form-label" htmlFor="username">
                          Username
                        </label>
                        <input
                          value={email} 
                          onChange={(e) => setEmail(e.target.value)}
                          type="text"
                          className="form-control"
                          id="username"
                          name="username"
                          placeholder="Enter username"
                        />
                      </div>

                      <div className="form-group">
                        <label className="form-label" htmlFor="userpassword">
                          Password
                        </label>
                        <input
                          value={password} type="password" 
                          onChange={(e) => setPassword(e.target.value)}
                          type="password"
                          className="form-control"
                          name="password"
                          id="userpassword"
                          placeholder="Enter password"
                        />
                      </div>

                      <div className="form-group row mt-3">
                        <div className="col-sm-6">
                          <div className="form-check form-switch form-switch-success">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="customSwitchSuccess"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customSwitchSuccess"
                            >
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6 text-end">
                          <Link
                            to="/auth-recover-pw"
                            className="text-muted font-13"
                          >
                            <i className="dripicons-lock"></i> Forgot password?
                          </Link>
                        </div>
                      </div>

                      <div className="form-group mb-0 row">
                        <div className="col-12">
                          <div className="d-grid mt-3">
                            <button className="btn btn-primary" type="submit">
                              Log In <i className="fas fa-sign-in-alt ms-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>

                    <div className="text-center mb-2">
                      <p className="text-muted">
                        Don't have an account ?{' '}
                        <Link to="/register" className="text-primary ms-2">
                          Free Register
                        </Link>
                      </p>
                      <h6 className="px-3 d-inline-block">Or Login With</h6>
                    </div>

                    <div className="d-flex justify-content-center">
                      <a
                        href="#"
                        className="d-flex justify-content-center align-items-center thumb-md bg-blue-subtle text-blue rounded-circle me-2"
                      >
                        <i className="fab fa-facebook align-self-center"></i>
                      </a>
                      <a
                        href="#"
                        className="d-flex justify-content-center align-items-center thumb-md bg-info-subtle text-info rounded-circle me-2"
                      >
                        <i className="fab fa-twitter align-self-center"></i>
                      </a>
                      <a
                        href="#"
                        className="d-flex justify-content-center align-items-center thumb-md bg-danger-subtle text-danger rounded-circle"
                      >
                        <i className="fab fa-google align-self-center"></i>
                      </a>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>     
    </div>
  );
};

export default Login;
